$(document).ready(function() {
    const swiper2 = new Swiper('.swiper-reviews', {
      direction: 'horizontal',
      
      slidesPerView: 1.1,
      spaceBetween: 8,
      centerInsufficientSlides: true,
      centeredSlides: true,
      loop: true,
      
      breakpoints: {  
        768: {       
          slidesPerView: 2,
          spaceBetween: 12,
          centeredSlides: false,
          loop: true
        },
       1100: {       
          slidesPerView: 3,
          spaceBetween: 12,
          centeredSlides: false,
          loop: true
        }
      },

      pagination: {
        el: '.slider__pagination',
        clickable: true,
      },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

    });
  });